import { Util, Request } from "@xt/xtbase";

const { getOrigin } = Util;
const { XtAxios4 } = Request;

const SAPI_V4 = () => `${getOrigin("www")}/sapi/v4`;

function hyperpayCardUrl(path) {
  return `${SAPI_V4()}/payment/hyperpay/card${path}`;
}

/** 关闭全局错误弹窗（axios interceptor 的 autoErrorModal）与 XtAxios errorPop */
const silentConfig = (config) => ({
  ...config,
  isAutoPopError: false,
  autoErrorModal: false,
  errorPop: false,
});

/** GET /payment/hyperpay/card/entry/status — 入口状态聚合 */
export function get_hyperpayCardEntryStatus(config) {
  return XtAxios4.get(hyperpayCardUrl("/entry/status"), silentConfig(config));
}

/** GET /payment/hyperpay/card/eligibility — 开卡资格检查 */
export function get_hyperpayCardEligibility(config) {
  return XtAxios4.get(hyperpayCardUrl("/eligibility"), silentConfig(config));
}

/** GET /payment/hyperpay/card/cardInfo — 虚拟卡费用及配置信息 */
export function get_hyperpayCardInfo(config) {
  return XtAxios4.get(hyperpayCardUrl("/cardInfo"), silentConfig(config));
}

/** GET /payment/hyperpay/card/list — 卡种列表 */
export function get_hyperpayCardList(config) {
  return XtAxios4.get(hyperpayCardUrl("/list"), silentConfig(config));
}

function withPayCurrencyParams(config, payCurrency) {
  const normalized = payCurrency != null && String(payCurrency).trim() !== ""
    ? String(payCurrency).trim().toUpperCase()
    : "";
  if (!normalized) return config;
  return {
    ...config,
    params: {
      payCurrency: normalized,
      ...config?.params,
    },
  };
}

/** GET /payment/hyperpay/card/apply/precheck — 申请前余额预检 */
export function get_hyperpayCardApplyPrecheck({ payCurrency, ...config } = {}) {
  return XtAxios4.get(
    hyperpayCardUrl("/apply/precheck"),
    silentConfig(withPayCurrencyParams(config, payCurrency))
  );
}

/** POST /payment/hyperpay/card/apply — 提交开卡申请 */
export function post_hyperpayCardApply(data, { payCurrency, ...config } = {}) {
  return XtAxios4.post(
    hyperpayCardUrl("/apply"),
    data,
    silentConfig(withPayCurrencyParams(config, payCurrency))
  );
}

/** POST /payment/hyperpay/card/apply/status — 查询最新开卡申请状态 */
export function post_hyperpayCardApplyStatus(config) {
  return XtAxios4.post(hyperpayCardUrl("/apply/status"), null, silentConfig(config));
}

/** POST /payment/hyperpay/card/attachment/upload — 补传附件（WAIT_ATTACHMENT） */
export function post_hyperpayCardAttachmentUpload(data, config) {
  return XtAxios4.post(hyperpayCardUrl("/attachment/upload"), data, silentConfig(config));
}

/** GET /payment/hyperpay/card/balance — §三-8 卡片余额及脱敏卡号（cardId = hyperPayCardId） */
export function get_hyperpayCardBalance(hyperPayCardId, config) {
  return XtAxios4.get(
    hyperpayCardUrl("/balance"),
    silentConfig({
      ...config,
      params: { cardId: hyperPayCardId, ...config?.params },
    })
  );
}

/** POST /payment/hyperpay/card/sensitive — §三-9 完整卡号/CVV/有效期（cardId = hyperPayCardId） */
export function post_hyperpayCardSensitive(hyperPayCardId, config) {
  return XtAxios4.post(
    hyperpayCardUrl("/sensitive"),
    null,
    silentConfig({
      ...config,
      params: { cardId: hyperPayCardId, ...config?.params },
    })
  );
}

// §三-10 POST /payment/hyperpay/card/operation — 冻结/解冻/销卡等，暂无对应页面入口，暂不接入

/** GET §六-18 USDT 资金流水（开卡扣款 / 充值扣款 / 退回） */
export function get_hyperpayCardFundList({ pageIndex, pageSize } = {}, config = {}) {
  return XtAxios4.get(
    hyperpayCardUrl("/fund/list"),
    silentConfig({
      ...config,
      params: {
        ...(pageIndex != null ? { pageIndex } : {}),
        ...(pageSize != null ? { pageSize } : {}),
        ...config?.params,
      },
    })
  );
}
